/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./v3-game-difficulty-instance.vue?vue&type=template&id=57621724&scoped=true&"
import script from "./v3-game-difficulty-instance.vue?vue&type=script&lang=js&"
export * from "./v3-game-difficulty-instance.vue?vue&type=script&lang=js&"
import style0 from "./v3-game-difficulty-instance.vue?vue&type=style&index=0&id=57621724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57621724",
  null
  
)

export default component.exports